import { Module } from '@nestjs/common';
import { SifenPayloadModule } from 'src/facturas/sifen-payload.module';
import { NotaCreditoPayloadModule } from 'src/nota-creditos/nota-credito-payload.module';
import { NotaRemisionPayloadModule } from 'src/nota-remision/nota-remision-payload.module';
import { KudeController } from './kude.controller';
import { KudeService } from './kude.service';

@Module({
  imports: [SifenPayloadModule, NotaCreditoPayloadModule, NotaRemisionPayloadModule],
  controllers: [KudeController],
  providers: [KudeService],
  exports: [KudeService],
})
export class KudeModule {}
